import { render, staticRenderFns } from "./NotificationDetails.vue?vue&type=template&id=55f114dc&scoped=true&"
import script from "./NotificationDetails.vue?vue&type=script&lang=ts&"
export * from "./NotificationDetails.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationDetails.vue?vue&type=style&index=0&id=55f114dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f114dc",
  null
  
)

export default component.exports